// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumb_container__ReAhq","list":"Breadcrumb_list__3RUNH","item":"Breadcrumb_item__3QAwA","link":"Breadcrumb_link__2_8a5"};